import {
  Component,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe, NgClass } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-dropdown-menu',
  template: `
    <div class="relative">
      <!-- Bouton qui ouvre le menu -->
      <app-link-highlight
        (click)="toggleMenu()"
        [forceActive]="isDropdownPageActive$ | async"
      >
        Louer ma salle
        <i
          class="far fa-chevron-down transition-transform duration-300"
          [ngClass]="{ 'rotate-180': isOpen() }"
        ></i>
      </app-link-highlight>

      <!-- Overlay sombre -->
      @if (isOpen()) {
        <div
          class="fixed inset-0 bg-black/50 transition-opacity"
          (click)="isOpen.set(false)"
        >
        </div>
      }

      <!-- Menu déroulant -->
      @if (isOpen()) {
        <div
          @slideDown
          class="absolute left-0 z-50 mt-2 w-48 rounded-lg bg-white shadow-lg"
        >
          <div
            class="flex flex-col items-center justify-center space-y-2 px-2 py-4"
          >
            <app-link-highlight
              [small]="true"
              (click)="toggleMenu()"
              routerLink="/louer-ma-salle/a-propos"
              >Découvrir</app-link-highlight
            >
            <app-link-highlight
              [small]="true"
              (click)="toggleMenu()"
              routerLink="/louer-salle/demo"
              >Démo</app-link-highlight
            >
            <app-link-highlight
              [small]="true"
              (click)="toggleMenu()"
              routerLink="/louer-ma-salle/tarifs"
              >Tarifs</app-link-highlight
            >
            <app-link-highlight
              [small]="true"
              (click)="toggleMenu()"
              routerLink="/auth/devenir-un-hote"
              >Devenir hôte</app-link-highlight
            >
            <app-link-highlight
              routerLink="/louer-ma-salle/contact"
              [small]="true"
              (click)="toggleMenu()"
              >Contact</app-link-highlight
            >
          </div>
        </div>
      }
    </div>
  `,
  imports: [NgClass, SharedModule, AsyncPipe],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate(
          '200ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        animate(
          '150ms ease-in',
          style({ opacity: 0, transform: 'translateY(-10px)' }),
        ),
      ]),
    ]),
  ],
})
export class DropdownMenuComponent {
  isOpen = signal(false);
  private router = inject(Router);
  private dropdownPages = [
    '/louer-ma-salle/a-propos',
    '/louer-ma-salle/tarifs',
    '/auth/devenir-un-hote',
    '/louer-ma-salle/contact',
  ];
  isDropdownPageActive$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => this.dropdownPages.includes(this.router.url)),
  );

  constructor(private elementRef: ElementRef) {}

  toggleMenu() {
    this.isOpen.set(!this.isOpen());
  }

  // Ferme le menu si on clique ailleurs
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
